module.exports = __webpack_public_path__ + "img/pf-main-logo-blue.76eeee5b.png";